export { NgPatientModule } from './lib/ng-patient.module';
